import Sourveys from "./Surveys";

export default Sourveys;
